import AWS from 'aws-sdk';

// Configure AWS SDK
AWS.config.update({
  region: 'us-east-2', // e.g., 'us-east-1'
  // credentials, if necessary, though for web browsers, it's often managed differently
});

// Initialize and export CognitoIdentityServiceProvider
export const cognitoServiceProvider = new AWS.CognitoIdentityServiceProvider();
